import React, {useState, useEffect, useCallback} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stepper,
  Step,
  StepLabel,
  Box,
  Typography,
  FormControl,
  Chip,
  TextField,
  Checkbox,
  Paper,
  FormControlLabel,
  FormGroup, IconButton,
} from '@mui/material';
import {Close, Delete} from '@mui/icons-material';
import { ClientData } from '../../types';
import {filterProfileSettings, getPrefilledClientData, profileSettingsItems, profileSettingsOptions} from '../../utils';
import { useSources } from "../../context/SourcesContext";


interface ClientDataDialogProps {
  open: boolean;
  onClose: () => void;
}

const ClientDataDialog: React.FC<ClientDataDialogProps> = ({
  open,
  onClose,
}) => {
  const { discardData } = useSources();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Discard data</Typography>
          <IconButton onClick={onClose}><Close /></IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Attention
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            All sources and categories will be deleted!
          </Typography>
          <Button
              variant="outlined"
              startIcon={<Delete />}
              onClick={discardData}
              size="small"
              sx={{
                borderColor: 'error.main',
                color: 'error.main',
                '&:hover': {
                  borderColor: 'error.dark',
                  color: 'error.dark',
                  backgroundColor: 'error.light'
                }
              }}
          >
            Discard all monitoring data
          </Button>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientDataDialog; 